import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 生产环境：config.js / REACT_APP_API_BASE 指向后端时，转发 /api 请求
function getResolvedApiBase() {
  const runtime =
    typeof window !== "undefined" && window.__RUNTIME_CONFIG__
      ? window.__RUNTIME_CONFIG__
      : null;
  if (runtime && Object.prototype.hasOwnProperty.call(runtime, "API_BASE")) {
    return String(runtime.API_BASE || "").replace(/\/$/, "");
  }
  return (process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");
}

let API_BASE = getResolvedApiBase();

// HTTPS 页面禁止把 /api 转到 http://IP:端口（会 mixed-content 被浏览器拦截）
if (
  typeof window !== "undefined" &&
  window.location.protocol === "https:" &&
  API_BASE.startsWith("http://")
) {
  console.warn("[api] HTTPS 页面忽略不安全的 API_BASE:", API_BASE);
  API_BASE = "";
  if (window.__nativeFetch__) {
    window.fetch = window.__nativeFetch__;
  }
}

function toApiUrl(url) {
  if (!API_BASE || typeof url !== "string") return url;
  if (url.startsWith("/api")) return `${API_BASE}${url}`;
  if (url.startsWith("http")) {
    try {
      const parsed = new URL(url);
      if (parsed.pathname.startsWith("/api")) {
        return `${API_BASE}${parsed.pathname}${parsed.search}`;
      }
    } catch {
      return url;
    }
  }
  return url;
}

if (API_BASE) {
  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    if (typeof input === "string") {
      return nativeFetch(toApiUrl(input), init);
    }
    if (input instanceof Request) {
      const path = input.url.replace(window.location.origin, "");
      if (path.startsWith("/api")) {
        return nativeFetch(`${API_BASE}${path}`, init);
      }
    }
    return nativeFetch(input, init);
  };

  if (navigator.sendBeacon) {
    const nativeBeacon = navigator.sendBeacon.bind(navigator);
    navigator.sendBeacon = (url, data) => {
      const target = toApiUrl(url);
      if (
        window.location.protocol === "https:" &&
        typeof target === "string" &&
        target.startsWith("http://")
      ) {
        return nativeBeacon(url, data);
      }
      return nativeBeacon(target, data);
    };
  }
}

// 去掉后端注入的爬虫正文块，避免顶在导航上方（源码里爬虫仍能抓到首包 HTML）
try {
  const seo = document.getElementById("seo-prerender");
  if (seo && seo.parentNode) seo.parentNode.removeChild(seo);
} catch {
  /* ignore */
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
